<template>
  <div class="text-image">
    <v-image :image="content.image" v-observe-visibility="{ callback: animate, once: true }" />

    <div class="text">
      <v-rich-text :content="content.text" v-observe-visibility="{ callback: animate, once: true }" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'text-image',
  props: {
    content: {
      type: Object,
    },
  },
  methods: {
    animate(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add('animate__animated', 'animate__fadeInUp');
      }
    },
  },
  components: {
    vRichText: () => import('@/components/rich-text'),
    vImage: () => import('@/components/image'),
  },
};
</script>
